export const reportReducer = (state = {}, action) => {
  switch (action.type) {
    case "onLoadSongsReports": {
      return {
        ...state,
        reportsData: [...action.payload],
      };
    }
    default: {
      return {
        ...state,
      };
    }
  }
};
